import React from "react";
import { calcRendimientoBruto, calcManchaPorcentaje, calcPesoCafeLimpio, calcRendimientoExportable } from "./calidad-calculos.js";
import { ReactHookFormInput } from "../../../nuup/componentes/Forms/ReactHookFormInput.jsx";
import { ReactHookFormSelect } from "../../../nuup/componentes/Forms/ReactHookFormSelect.jsx";
import LabelNumber from "../../../components/label/label-number.jsx";

const CalidadAnalisisFisicoForm = ({ control, errors, getValues, watch, onOroDerivedRecalc }) => {
  const pesoMuestra = Number(watch?.('analisis_fisico.pergamino_peso_muestra_pergamino'));
  const pesoOro = Number(watch?.('analisis_fisico.pergamino_peso_muestra_oro'));
  const manchaGr = Number(watch?.('analisis_fisico.pergamino_peso_mancha'));
  const rendimientoBruto = calcRendimientoBruto(pesoMuestra, pesoOro);
  const manchaPorcentaje = calcManchaPorcentaje(pesoMuestra, manchaGr);
  const pesoCafeLimpio = calcPesoCafeLimpio(pesoOro, manchaGr);
  const rendimientoExportable = calcRendimientoExportable(pesoMuestra, pesoOro, manchaGr);
  return (
    <>
      <div className="row mt-3">
            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="number"
                id="analisis_fisico.pergamino_peso_muestra_pergamino"
                name="analisis_fisico.pergamino_peso_muestra_pergamino"
                label="Peso de la muestra (grs.) *"
                error={errors?.analisis_fisico?.pergamino_peso_muestra_pergamino}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_peso_muestra_pergamino}
                onBlurExternal={typeof onOroDerivedRecalc === 'function' ? onOroDerivedRecalc : undefined}
              />
            </div>
            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="number"
                id="analisis_fisico.pergamino_humedad"
                name="analisis_fisico.pergamino_humedad"
                label="Humedad (%) *"
                error={errors?.analisis_fisico?.pergamino_humedad}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_humedad}
              />
            </div>
    

            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="text"
                id="analisis_fisico.olor_muestra"
                name="analisis_fisico.olor_muestra"
                label="Olor / Aroma"
                error={errors?.analisis_fisico?.olor_muestra}
                control={control}
                value={getValues()?.analisis_fisico?.olor_muestra}
              />
            </div>


            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="text"
                id="analisis_fisico.pergamino_densidad"
                name="analisis_fisico.pergamino_densidad"
                label="Densidad (g./l.)"
                error={errors?.analisis_fisico?.pergamino_densidad}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_densidad}
              />
            </div>
          </div>



      <div className="row mt-1">


            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="number"
                id="analisis_fisico.pergamino_peso_muestra_oro"
                name="analisis_fisico.pergamino_peso_muestra_oro"
                label="Peso en Oro (grs.) *"
                error={errors?.analisis_fisico?.pergamino_peso_muestra_oro}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_peso_muestra_oro}
              />
            </div>

            <div className="col-lg-3 mt-2">

              <ReactHookFormInput
                type="number"
                id="analisis_fisico.pergamino_peso_mancha"
                name="analisis_fisico.pergamino_peso_mancha"
                label="Mancha / Defectos (grs)"
                error={errors?.analisis_fisico?.pergamino_peso_mancha}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_peso_mancha}
              />

            </div>
 


            <div className="col-lg-3 mt-2">



              <ReactHookFormSelect
                placeholder="Color de la muestra"
                label="Color de la muestra"
                id={'analisis_fisico.id_color_muestra'}
                name={'analisis_fisico.id_color_muestra'}
                error={errors?.analisis_fisico?.id_color_muestra ? true : false}
                url={"calidad/catalogos/color_muestra"}
                keyArray="id"
                labelArray="nombre"
                apiSearch={false}
                control={control}
                value={getValues()?.analisis_fisico?.id_color_muestra}
              />


            </div>
            <div className="col-lg-3 mt-2">
              <ReactHookFormInput
                type="number"
                id="analisis_fisico.pergamino_actividad_agua"
                name="analisis_fisico.pergamino_actividad_agua"
                label="Actividad en agua"
                error={errors?.analisis_fisico?.pergamino_actividad_agua}
                control={control}
                value={getValues()?.analisis_fisico?.pergamino_actividad_agua}
              />
            </div>
           </div>

      <div className="row mt-3">
        <div className="col-lg-6">
          <div className="row">
            <div className="col-lg-5">
              <span style={{ fontWeight: 'bold' }}>{`Rendimiento Bruto (%): ${rendimientoBruto !== '' ? rendimientoBruto : '-'}`}</span>
            </div>
            <div className="col-lg-5">
              <span style={{ fontWeight: 'bold' }}>{`Mancha / Defectos (%): ${manchaPorcentaje !== '' ? manchaPorcentaje : '-'}`}</span>
            </div>
            <div className="col-lg-2"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalidadAnalisisFisicoForm;
